export const PARTNERS_LIST = [
  {
    key: "scb",
    imgUrl: "/assets/partners/scb.svg",
  },
  {
    key: "laser",
    imgUrl: "/assets/partners/laser.svg",
  },
  {
    key: "bankless",
    imgUrl: "/assets/partners/bankless.svg",
  },
  {
    key: "hypersphere",
    imgUrl: "/assets/partners/hypersphere.svg",
  },
  {
    key: "draper",
    imgUrl: "/assets/partners/draper.svg",
  },
  {
    key: "dacm",
    imgUrl: "/assets/partners/dacm.svg",
  },
  {
    key: "cypher",
    imgUrl: "/assets/partners/cypher.svg",
  },
  {
    key: "arkstream",
    imgUrl: "/assets/partners/arkstream.svg",
  },
  {
    key: "cluster",
    imgUrl: "/assets/partners/cluster.svg",
  },
  {
    key: "gsr",
    imgUrl: "/assets/partners/gsr.svg",
  },
  {
    key: "longhash",
    imgUrl: "/assets/partners/longhash.svg",
  },
  {
    key: "sidedoor",
    imgUrl: "/assets/partners/sidedoor.svg",
  },
  {
    key: "noia",
    imgUrl: "/assets/partners/noia.svg",
  },
  {
    key: "htx",
    imgUrl: "/assets/partners/htx.svg",
  },
  {
    key: "viabtc",
    imgUrl: "/assets/partners/viabtc.svg",
  },
  {
    key: "dwf",
    imgUrl: "/assets/partners/dwf.svg",
  },
  {
    key: "coinseeker",
    imgUrl: "/assets/partners/coinseeker.svg",
  },
  {
    key: "tulipa",
    imgUrl: "/assets/partners/tulipa.svg",
  },
];

export type InfoDataType = {
  title: string;
  details: string[];
  bgImg: string;
  link: string;
};

export const KELP_INFO: InfoDataType[] = [
  {
    title: "Restake",
    details: [
      "Deposit ETH, stETH, or ETHx and get rsETH",
      "Maximise rewards through 100+ DeFi opportunities",
      "Earn Kernel Points & EigenLayer Points",
      "Restake on 10+ Networks",
    ],
    bgImg: "/assets/info/rseth.svg",
    link: "/restake",
  },
  {
    title: "Gain",
    details: [
      "Get top Airdrop & higher rewards",
      "Earnings on Autopilot",
      "Accepts ETH, stETH, ETHx, or rsETH",
      "Double the rewards with DeFi",
    ],
    bgImg: "/assets/info/gain.svg",
    link: "/gain",
  },
  {
    title: "Institutions",
    bgImg: "/assets/info/insti.svg",
    details: [
      "Investment Strategies on 10+ Networks",
      "Top DeFi opportunities across Restaking & Gain",
    ],
    link: "/institutions",
  },
];

export type ecosystemData = {
  [key: string]: {
    title: string;
    data: {
      title: string;
      imgUrl: string;
    }[];
  };
};

export const ECOSYSTEM_DATA: ecosystemData = {
  l2: {
    title: "L2 chains",
    data: [
      {
        title: "Arbitrum",
        imgUrl: "/assets/ecosystem/l2/arb.svg",
      },
      {
        title: "Blast",
        imgUrl: "/assets/ecosystem/l2/blast.svg",
      },
      {
        title: "Linea",
        imgUrl: "/assets/ecosystem/l2/linea.svg",
      },
      {
        title: "Scroll",
        imgUrl: "/assets/ecosystem/l2/scroll.svg",
      },
      {
        title: "zkSync",
        imgUrl: "/assets/ecosystem/l2/zk.svg",
      },
      {
        title: "X layer",
        imgUrl: "/assets/ecosystem/l2/xlayer.svg",
      },
      {
        title: "Optimism",
        imgUrl: "/assets/ecosystem/l2/op.svg",
      },
      {
        title: "Base",
        imgUrl: "/assets/ecosystem/l2/base.svg",
      },
      {
        title: "Mode",
        imgUrl: "/assets/ecosystem/l2/mode.svg",
      },
    ],
  },
  defi_partners: {
    title: "DeFi partners",
    data: [
      {
        title: "Compound",
        imgUrl: "/assets/ecosystem/defi/compound.svg",
      },
      {
        title: "Gearbox",
        imgUrl: "/assets/ecosystem/defi/gearbox.svg",
      },
      {
        title: "Pendle",
        imgUrl: "/assets/ecosystem/defi/pendle.svg",
      },
      {
        title: "Curve",
        imgUrl: "/assets/ecosystem/defi/curve.svg",
      },
      {
        title: "Balancer",
        imgUrl: "/assets/ecosystem/defi/balancer.svg",
      },
      {
        title: "Camelot",
        imgUrl: "/assets/ecosystem/defi/camelot.svg",
      },
      {
        title: "Uniswap",
        imgUrl: "/assets/ecosystem/defi/uni.svg",
      },
      {
        title: "Thruster",
        imgUrl: "/assets/ecosystem/defi/thruster.svg",
      },
      {
        title: "Ambient",
        imgUrl: "/assets/ecosystem/defi/ambient.svg",
      },
      {
        title: "Layerbank",
        imgUrl: "/assets/ecosystem/defi/layerbank.svg",
      },
      {
        title: "Zerolend",
        imgUrl: "/assets/ecosystem/defi/zerolend.svg",
      },
    ],
  },
  avs: {
    title: "AVSs",
    data: [
      {
        title: "EigenDA",
        imgUrl: "/assets/ecosystem/avs/eigen.svg",
      },
      {
        title: "eOracle",
        imgUrl: "/assets/ecosystem/avs/eoracle.svg",
      },
      {
        title: "Automata",
        imgUrl: "/assets/ecosystem/avs/automata.svg",
      },
      {
        title: "Witness Chain",
        imgUrl: "/assets/ecosystem/avs/witness.svg",
      },
      {
        title: "Cyber Mach",
        imgUrl: "/assets/ecosystem/avs/cybermatch.svg",
      },
      {
        title: "Hyperlane",
        imgUrl: "/assets/ecosystem/avs/hyperlane.svg",
      },
      {
        title: "Openlayer",
        imgUrl: "/assets/ecosystem/avs/openlayer.svg",
      },
      {
        title: "Brevis coChain",
        imgUrl: "/assets/ecosystem/avs/brevis.svg",
      },
    ],
  },
  operators: {
    title: "Operators",
    data: [
      {
        title: "Kiln",
        imgUrl: "/assets/ecosystem/operators/klin.svg",
      },
      {
        title: "Allnodes",
        imgUrl: "/assets/ecosystem/operators/allnodes.svg",
      },
      {
        title: "Luganodes",
        imgUrl: "/assets/ecosystem/operators/luganodes.svg",
      },
      {
        title: "Omakase",
        imgUrl: "/assets/ecosystem/operators/omakase.svg",
      },
    ],
  },
};
